module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-cancel-d06df2fd1ed53003863cddfcb6996729.png";